import { Card, Col, Row } from "antd";
import React from "react";
import { TIMESHEET_TAB_CHIPS } from "../../TimeSheetConstants";
import { TimesheetData } from "../TimesheetData/TimesheetData";
import "./TimeSheetChips.css";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loading/Loader";
const TimeSheetTab = ({ handleApproveRejectClick, handlePageChange, page }) => {
  const timesheetData = useSelector((state) => state.TimesheetListReducer.data);
  const loading = useSelector((state) => state.TimesheetListReducer.loading);
  const Chip = ({ title, keyName }) => {
    const getCount = () => {
      try {
        return timesheetData.counts[keyName].formatted || "0 hrs";
      } catch (error) {
        return "0 hrs";
      }
    };
    return (
      <div className="time-sheet-chips">
        <p className="time-sheet-chip-title">{title}</p>
        <p className="time-sheet-chip-count">{getCount()}</p>
      </div>
    );
  };

  if (loading) return <Loader />;

  return (
    <Row style={{ marginTop: "10px" }} gutter={[0, 10]}>
      <Col span={24}>
        <Row
          wrap={false}
          className="chips-container"
          style={{}}
          gutter={[{ xs: 5, sm: 6, md: 8, lg: 10 }, 0]}
        >
          {TIMESHEET_TAB_CHIPS.map((chip) => (
            <Col>
              <Chip title={chip.title} keyName={chip.key} />
            </Col>
          ))}
        </Row>
      </Col>
      <Col span={24}>
        <TimesheetData
          page={page}
          data={timesheetData?.data}
          handleApproveRejectClick={handleApproveRejectClick}
          handlePageChange={handlePageChange}
        />
      </Col>
    </Row>
  );
};

export { TimeSheetTab };
